import { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { RoleDropdown } from '../RoleDropdown';
import { UserAvatar } from 'src/components';
import type { MembershipRole } from 'src/types';

type Props = {
  invitee: { email: string; role: MembershipRole };
  index: number;
  handleUpdateRole: (email: string, role: MembershipRole) => void;
  handleRemoveInvitee: (email: string) => void;
};

export const InviteeDetails = ({
  invitee,
  index,
  handleUpdateRole,
  handleRemoveInvitee,
}: Props) => {
  const [showRoleDropdown, setShowRoleDropdown] = useState(false);

  return (
    <div
      key={`invitee-${index}`}
      className='flex h-12 w-full flex-row flex-nowrap items-center justify-center gap-3 rounded-lg bg-offWhite p-2'
    >
      <UserAvatar name={invitee.email.toUpperCase()} />
      <span className='text-100 grow text-left'>{invitee.email}</span>
      <RoleDropdown
        showDropdown={showRoleDropdown}
        handleShowDropdown={() => setShowRoleDropdown(!showRoleDropdown)}
        isPending={false}
        displayPending={false}
        role={invitee.role}
        handleSelectRole={(role) => {
          handleUpdateRole(invitee.email, role);
        }}
        dropdownId={`invitee-role-dropdown-${index}`}
        userId={invitee.email}
      />
      <button
        className='flex h-4 w-4 cursor-pointer items-center justify-center fill-darkSteel hover:fill-gray-400'
        onClick={() => handleRemoveInvitee(invitee.email)}
      >
        <CloseIcon
          className='transition-all'
          style={{ fontSize: '16px', fill: 'inherit' }}
        />
      </button>
    </div>
  );
};
